// Mimeeq Configurator → PostHog 事件埋点
// 依赖: PostHog JS SDK（已在 layout/theme.liquid <head> 初始化）
// 加载: layout/theme.liquid 中以 <script ... defer> 引入（可缓存、不阻塞解析）
//
// 页面上下文（page_type / template）有意不带：核心使用率/漏斗/转化分析不需要，
// page_type 可由 PostHog 自动属性 $pathname 推导；如将来需要 Shopify 模板级切分，
// 再用一小段 inline Liquid 注入 window 变量后在此读取即可。
//
// 接入方式为 Mimeeq 官方推荐：监听其在 document 上派发的 mimeeq-* CustomEvent，
// 推送到自有分析系统。官方文档：
//   - 事件总览:        https://docs.mimeeq.com/events/
//   - 配置事件明细:    https://docs.mimeeq.com/events/configuration/
//   - 用事件做使用分析(官方指南): https://help.mimeeq.com/en/article/using-events-to-track-product-configurator-usage-8nfedk/
//   - 分析集成示例(同款 addEventListener 写法): https://docs.mimeeq.com/google-analytics/
//
// 设计原则:
// - 外部 asset + defer 加载（可缓存、不阻塞解析），逻辑与 Liquid 数据解耦
// - 只发 PostHog，不碰 GA4/GTM（GA4 由 Google & YouTube App Pixel 独家负责，避免重复计数）
// - "加购/下单" 由 Mimeeq 真实写入 Shopify 购物车后沿用现有 Product Added / Order Completed 链路；
//   本埋点的 "Configurator Add to Cart" 仅作配置器维度归因，带 source:'mimeeq' 以便去重
// - select-option 量大，做节流，避免刷爆事件
// - 预览 gate 事件来自主题自己的弹窗（非 Mimeeq 派发），统一以 Mimeeq Gate * 命名，带 source:'mimeeq_gate'

(function () {
  if (typeof posthog === 'undefined') return;
  if (window.__mimeeqAnalyticsBound) return;
  window.__mimeeqAnalyticsBound = true;

  // 从 Mimeeq event.detail 里安全抽取常用字段（payload 因事件类型而异）
  function pick(detail) {
    detail = detail || {};
    var out = {};
    var map = {
      configuration_code: detail.configurationCode,
      configuration_short_code: detail.configurationShortCode || detail.shortCode,
      mmq_product_id: detail.productId,
      mmq_product_name: detail.productName,
      is_modular: detail.isModular,
      sku: detail.sku,
      variant_code: detail.variantCode,
      embed_short_code: detail.embedShortCode,
      currency: detail.currency,
      qty: detail.qty
    };
    for (var k in map) {
      if (map[k] !== undefined && map[k] !== null) out[k] = map[k];
    }
    if (detail.price != null) out.price = Number(detail.price);
    if (detail.unitPrice != null) out.unit_price = Number(detail.unitPrice);
    return out;
  }

  function capture(name, detail, extra) {
    try {
      var props = pick(detail);
      if (extra) { for (var e in extra) props[e] = extra[e]; }
      posthog.capture(name, props);
    } catch (err) { /* 静默失败，绝不影响配置器 */ }
  }

  function on(eventName, handler) {
    document.addEventListener(eventName, handler);
  }

  // ── 0. 预览 gate（进配置器之前的一道拦截）──
  // 由 snippets/mimeeq-preview-modal.liquid 派发 CustomEvent，事件命名统一收在本文件。
  // Dismissed / Opened 就是省下来的 Mimeeq session 比例；
  // Entered 之后会接上下面的 Configurator Loaded / Entered，漏斗自动续上。
  function onGate(name) {
    return function (e) {
      var d = (e && e.detail) || {};
      capture(name, null, {
        source: 'mimeeq_gate',
        product_handle: d.product_handle,
        product_title: d.product_title
      });
    };
  }
  on('mopio:mimeeq-gate-opened', onGate('Mimeeq Gate Opened'));
  on('mopio:mimeeq-gate-entered', onGate('Mimeeq Gate Entered'));
  on('mopio:mimeeq-gate-dismissed', onGate('Mimeeq Gate Dismissed'));

  // ── 1. 生命周期 ──
  on('mimeeq-app-loaded', function () { capture('Configurator Loaded'); });
  on('mimeeq-3d-product-initialized', function () { capture('Configurator 3D Ready'); });
  on('mimeeq-webgl-not-supported', function () { capture('Configurator WebGL Failed'); });

  // ── 2. 进入配置（标准 + 模块化都覆盖）──
  on('mimeeq-enter-product', function (e) { capture('Configurator Entered', e.detail, { mode: 'standard' }); });
  on('mimeeq-modular-enter-product', function (e) { capture('Configurator Entered', e.detail, { mode: 'modular' }); });

  // ── 3. 配置深度（节流 + 累计计数）──
  // 单次 option 选择量很大，节流到最多 1.5s 一次，但用计数器记录真实深度
  var optionSelectCount = 0;
  var lastOptionCapture = 0;
  function onOptionSelect(e) {
    optionSelectCount++;
    var now = Date.now();
    if (now - lastOptionCapture < 1500) return; // 节流：丢弃中间高频事件
    lastOptionCapture = now;
    capture('Configurator Option Selected', e.detail, { option_select_count: optionSelectCount });
  }
  on('mimeeq-select-option', onOptionSelect);
  on('mimeeq-modular-select-option', onOptionSelect);

  // 模块化：往场景加模块 = 模块化最核心的交互信号
  var sceneModuleCount = 0;
  on('mimeeq-modular-add-product-to-scene', function (e) {
    sceneModuleCount++;
    capture('Configurator Module Added', e.detail, { scene_module_count: sceneModuleCount });
  });

  // ── 4. 完成配置（点 Finish）──
  function onSummary(e) {
    capture('Configurator Summary Opened', e.detail, {
      option_select_count: optionSelectCount,
      scene_module_count: sceneModuleCount
    });
  }
  on('mimeeq-show-summary', onSummary);
  on('mimeeq-modular-open-summary', onSummary);

  // ── 5. 从配置器加购（带 source:'mimeeq' 用于和主题 Product Added 去重）──
  on('mimeeq-add-to-cart', function (e) {
    capture('Configurator Add to Cart', e.detail, {
      source: 'mimeeq',
      option_select_count: optionSelectCount,
      scene_module_count: sceneModuleCount
    });
  });

  // ── 6. 导出 / AR（增值功能使用率）──
  on('mimeeq-pdf-generate-done', function (e) { capture('Configurator PDF Exported', e.detail); });
  on('mimeeq-generate-ar-short-code', function (e) { capture('Configurator AR Generated', e.detail); });
})();
